<template>
  <div v-if="showToast" @touchmove.prevent>
    <div class="toast-bg"></div>
    <div class="toast-center">
      <div class="toast">
        <img class="toast-icon" :src="showToast.icon" v-if="showToast.icon" />
        <div class="toast-text">{{showToast.message}}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* showToast */
.toast-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: transparent;
}

/* 水平居中必备样式 */
.toast-center {
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}

.toast {
  display: inline-block;
  padding: 20px 40px;
  max-width: 520px;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  text-align: center;
}

/* 垂直居中必备样式 */
.toast-center::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
}

.toast-icon {
  display: block;
  margin: 0 auto 10px;
  width: 100px;
  height: 100px;
}
</style>
<script>
export default {
  name: 'toast',
  data() {
    return {};
  },
  props: ['showToast'],
};
</script>



// WEBPACK FOOTER //
// src/components/toast.vue